import { useTranslation } from 'react-i18next';
import TrophyBadge from './TrophyBadge';
import IconRocket from '@/shared/icons/Gamification/IconRocket';
import {
  Card,
  CardTopRow,
  CardTrophyColumn,
  CardContentColumn,
  CardInfoRow,
  CardInfoColumn,
  CardLevelText,
  CardCategoryName,
  CardCounter,
  CardProgressBar,
  CardProgressFill,
} from './styled-components';

const MAX_LEVEL_KEY = 'elite';

const CategoryCard = ({ category }) => {
  const { t } = useTranslation('gamification');
  const isMaxLevel = category.currentLevelKey === MAX_LEVEL_KEY;
  const progressValue = category.total > 0
    ? (category.acquired / category.total) * 100
    : 0;

  return (
    <Card $maxLevel={isMaxLevel} style={{ position: 'relative' }}>
      {isMaxLevel && (
        <div style={{ position: 'absolute', top: '0.75rem', right: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
          <IconRocket style={{ width: '1rem', height: '1rem' }} />
          <span style={{ fontFamily: '"Inter", sans-serif', fontSize: '0.75rem', color: '#58595B' }}>
            <span style={{ fontWeight: 700, color: '#343535' }}>{category.acquired}</span> {t('salesLabel')}
          </span>
        </div>
      )}
      <CardTopRow>
        <CardTrophyColumn>
          <TrophyBadge
            categoryId={isMaxLevel ? null : category.id}
            trophyColor={category.currentLevelKey}
            dimmed={!category.currentLevelKey || category.currentLevelKey === 'empty'}
            numberOverlay={isMaxLevel ? 'check' : null}
            bannerLabel={category.currentLevelKey === 'starter' ? null : t(`level_${category.currentLevelKey || 'empty'}`)}
            bannerVariant={isMaxLevel ? 'completed' : (!category.currentLevelKey || category.currentLevelKey === 'empty' ? 'disabled' : 'default')}
          />
        </CardTrophyColumn>
        <CardContentColumn>
          <CardInfoRow>
            <CardInfoColumn>
              <CardLevelText>
                {t('levelPrefix')} {category.currentLevelOrder}
              </CardLevelText>
              <CardCategoryName>{category.name}</CardCategoryName>
            </CardInfoColumn>
            {!isMaxLevel && (
              <CardCounter>
                <span style={{ color: '#343535' }}>{category.acquired}</span>
                <span style={{ color: '#58595B', fontWeight: 400 }}>
                  <span style={{margin: '0 0.1rem'}}>/</span>{category.total}</span>
              </CardCounter>
            )}
          </CardInfoRow>
          {isMaxLevel ? (
            <span style={{
              fontFamily: '"Inter", sans-serif',
              fontSize: '0.75rem',
              color: '#58595B',
              fontStyle: 'italic',
            }}>
              {t('maxLevelMessage')}
            </span>
          ) : (
            <CardProgressBar>
              <CardProgressFill $width={Math.min(progressValue, 100)} />
            </CardProgressBar>
          )}
        </CardContentColumn>
      </CardTopRow>
    </Card>
  );
};

export default CategoryCard;
